import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function TripCard({ trip, index = 0 }) {
  const seatsPct = trip.seats_remaining / trip.seats_total;
  const seatColor = seatsPct < 0.3 ? "text-owt-terracotta" : "text-owt-forest";
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.8, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="group relative"
      data-testid={`trip-card-${trip.id}`}
    >
      <Link to={`/trips/${trip.id}`} className="block">
        <div className="relative aspect-[4/5] overflow-hidden bg-owt-sand">
          <motion.img
            src={trip.hero_image}
            alt={trip.name}
            loading="lazy"
            className="w-full h-full object-cover"
            whileHover={{ scale: 1.06 }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-owt-ink/70 via-transparent to-transparent"/>
          <div className="absolute top-4 left-4 right-4 flex items-start justify-between">
            <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-owt-surface bg-owt-forest/70 backdrop-blur px-2 py-1">
              {trip.country}
            </span>
            <span className={`font-mono text-[10px] tracking-[0.2em] uppercase bg-owt-surface/90 px-2 py-1 ${seatColor}`}>
              {trip.seats_remaining}/{trip.seats_total} seats
            </span>
          </div>
          <div className="absolute bottom-4 left-4 right-4 text-owt-surface">
            <div className="font-mono text-[10px] tracking-[0.2em] uppercase opacity-80">
              {new Date(trip.start_date).toLocaleDateString("en-GB", { month: "short", day: "numeric" })} — {new Date(trip.end_date).toLocaleDateString("en-GB", { month: "short", day: "numeric", year: "numeric" })}
            </div>
            <div className="font-display text-2xl md:text-3xl leading-tight mt-1">{trip.name}</div>
          </div>
        </div>
        <div className="mt-3 flex items-center justify-between">
          <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-owt-muted">{trip.duration_days} days · {trip.difficulty}</div>
          <div className="flex items-baseline gap-2">
            {trip.price > 0 ? (
              <>
                {trip.original_price && trip.original_price > trip.price && (
                  <span className="font-display text-sm text-owt-muted line-through decoration-owt-terracotta/70">₹{Number(trip.original_price).toLocaleString("en-IN")}</span>
                )}
                <span className="font-display text-lg text-owt-forest">₹{Number(trip.price).toLocaleString("en-IN")}</span>
              </>
            ) : (
              <span className="font-display text-lg text-owt-forest">Price on request</span>
            )}
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
